// Checked

import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import flag8 from "../../../assets/images/flag8.png";
import TextField from "@material-ui/core/TextField";
import flag_bd4 from "../../../assets/images/flag_bd4.png";
import flag_usa4 from "../../../assets/images/flag_usa4.png";
import { TransferContext } from "../../../context/TransferContext";

const useStyles = makeStyles(() => ({
  marginBottomStyle: {
    marginBottom: "10px",
  },

  inputStyle: {
    borderRadius: "8px",
  },
  inputStyle2: {
    borderRadius: "8px",
    // "& .MuiInputBase-input": {
    //   color: "#A2A2A2",
    // },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      fontSize: "14px",
      padding: 13,
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
  },
  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 13,
    },
  },
  selectStyle: {
    textAlign: "left",

    "& img": {
      position: "relative",
      top: "2px",
      marginRight: "5px",
    },
  },
  selectItemStyle: {
    fontWeight: 600,
  },
  inputRoot: {
    "& .MuiOutlinedInput-input": {
      // color: "green",
      // fontWeight: 600,
    },
    "& .MuiInputLabel-root": {
      // color: "green",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "#eee",
      // backgroundColor: "#eee",
      color: "#333",
    },
    "&:hover .MuiOutlinedInput-input": {
      // color: "red",
    },
    "&:hover .MuiInputLabel-root": {
      // color: "red",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      // color: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      // color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      // borderColor: "purple",
    },
  },
  flag: {
    marginRight: 10,
    width: 20,
    position: "relative",
    top: 4,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
      borderWidth: 0,
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 8,
  },
}));
const ReceiverDetails = () => {
  const classes = useStyles();
  const { addToTransfer, transfer } = useContext(TransferContext);

  const [mfs, setMfs] = useState([]);
  const [mfsId, setMfsId] = useState(transfer.mfsId && transfer.mfsId);
  const [accountName, setAccountName] = useState(transfer.accountName);
  const [mobileNumber, setMobileNumber] = useState(transfer.r_phone);
  const [phoneCode, setPhoneCode] = useState(
    transfer.toCountry && transfer.toCountry.code
  );

  const [flag, setFlag] = useState(
    transfer.toCountry && transfer.toCountry.flag
  );
  const [phone, setPhone] = useState(transfer.toCountry && transfer.toCountry.phone);


  const getMfs = async () => {
    try {
      let res = await axios({
        url: "/api/v1/public/mfs",
        method: "get",
      });

      setMfs(res.data.data);

      console.log("mfs", res.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
  };

  const handleMfs = (e) => {
    console.log(e.target.value);
    setMfsId(e.target.value);
    addToTransfer({ mfsId: e.target.value });
  };
  const handleAccountName = (e) => {
    setAccountName(e.target.value);
    addToTransfer({ accountName: e.target.value });
  };

  const HandleMobileNumber = (e) => {
    setMobileNumber(e.target.value);
    addToTransfer({ r_phone: e.target.value });

    addToTransfer({ accountNumber: `${phone}${e.target.value}` });
  };

  const handlePhoneCode = (e) => {

    let value = e.target.value;
    let myValue = transfer.countries.filter((event) => event.code === value);
    console.log("new", myValue);
    setPhoneCode(myValue[0].code);
    setPhone(myValue[0].phone);

    // setPhoneCode(e.target.value);
    addToTransfer({ r_phoneCode: myValue[0].phone });
    addToTransfer({ accountNumber: `${myValue[0].phone}${mobileNumber}` });

  };

  useEffect(() => {
    console.log("none");
    getMfs();
  }, []);

  return (
    <>
      {/* <Typography variant="h4" className={classes.marginBottomStyle}>
        Receiver Details
      </Typography> */}
      <Grid container alignItems="center" spacing={3}>
        <Grid item xs={3}>
          <Typography variant="body1">MFS Name</Typography>
        </Grid>
        <Grid item xs={9}>
          <FormControl variant="outlined" size="small" fullWidth>
            <Select
              labelId="MFS-name-outlined-label"
              id="MFS-name-outlined"
              defaultValue="na"
              value={mfsId}
              onChange={handleMfs}
              className={classes.inputStyle2}
            >
              <MenuItem disabled value="na">
                <span style={{ color: "#999" }}>Select One</span>
              </MenuItem>
              {mfs.map((e, index) => (
                <MenuItem value={e.id} key={index}>
                  {e.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="body1">Account Name</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            id="account-name"
            size="small"
            fullWidth
            placeholder="Enter account name"
            variant="outlined"
            className={classes.textField}
            value={accountName}
            onChange={handleAccountName}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body1">Account Number</Typography>
        </Grid>

        <Grid item xs={2}>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            fullWidth
          >
            <TextField
              className={classes.inputRoot}
              variant="outlined"
              displayEmpty
              defaultValue="na"
              select
              // disabled
              InputProps={{
                className: classes.select,
              }}
              size="small"
              value={phoneCode}
              onChange={handlePhoneCode}
            >
              <MenuItem value="na" disabled>
                <span style={{ color: "#999" }}>Select code</span>
              </MenuItem>
              {transfer.countries.map((item, index) => (
                <MenuItem value={item.code} key={index}>
                  <img src={item.flag} alt="" className={classes.flag} />
                  {item.phone}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>
        <Grid item xs={7}>
          <TextField
            id="number"
            size="small"
            fullWidth
            variant="outlined"
            placeholder="Enter Account Number"
            className={classes.textField}
            value={mobileNumber}
            onChange={HandleMobileNumber}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ReceiverDetails;
